/**src\presentation\router\routes.ts
 * Route Definitions
 *
 * Centralized route paths as constants.
 * This ensures type-safety and prevents typos in route paths.
 */

export const routes = {
  login: '/',
  newLogin: '/nuevousuario',
  ubicacionFormulario: '/ubicacion/formulario/:id?',
  ubicacion: '/ubicacion/:id',
  ubicaciones: '/ubicaciones',
  dashboard: '/dashboard',
  incidenteDetail: '/incidente/:id',
  equipos: '/equipos',
  equiposDetail: '/equipo/:id',
  equiposFormulario: '/equipo/formulario/:equipo?',
  visitas: '/visitas',
  visitaFormulario: '/visita/formulario',
  visitaDetail: '/visita/:id',
  actions: '/acciones/:id',
  repuestos: '/repuestos',
  users: '/users',
  notFound: '/404',
  unauthorized: '/401',
} as const;

export type RouteKey = keyof typeof routes;
